import { connect } from 'react-redux'
import SlidesButton from './SlidesButton'
import SlidesButtonProps from './types'
import { openSlidesMediaDrawer, closeSlidesMediaDrawer } from '../../dataStore/actions/ui/uiActions'
import constants, { mediaType } from '@bt-react/constants'
import selectSlideDeck from '../../dataStore/selectors/selectSlideDeck'
import { SlideDeck } from '../../lib/slides/types'
import { State } from '../../dataStore/reducers/reducerType'

type Dispatch = 'openMediaDrawer' | 'closeMediaDrawer'

const mapStateToProps = (state: State): Omit<SlidesButtonProps, Dispatch> => {

  const slideDeck: SlideDeck = selectSlideDeck(state)

  return {
    isActive: state.ui.selectedDrawer === constants.drawerType.SLIDES || state.room.mediaType === mediaType.SLIDES,
    slidesCount: slideDeck ? slideDeck.numberOfSlides : 0,
    mediaDrawerOpen: state.ui.selectedDrawer === constants.drawerType.SLIDES,
    isLoading: state.slides.isUploading || state.slides.isProcessing
  }

}

const mapDispatchToProps = (dispatch): Pick<SlidesButtonProps, Dispatch> => ({
  openMediaDrawer: () => dispatch(openSlidesMediaDrawer()),
  closeMediaDrawer: () => dispatch(closeSlidesMediaDrawer())
})

export default connect(mapStateToProps, mapDispatchToProps)(SlidesButton)
